import { useMediaQuery } from '@mui/material';

interface CatalogListArrangement {
  isStacked: boolean;
}

const THREE_COLUMNS_QUERY = '(min-width:1024px)';

export const useCatalogListArrangement = (): CatalogListArrangement => {
  const isThreeColumns = useMediaQuery(THREE_COLUMNS_QUERY, { noSsr: true });

  return { isStacked: !isThreeColumns };
};
